import * as React from "react"
import { AXIOS_API_INSTANCE } from "../../Constants"
import { FormControl, MenuItem, Select } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { useTrackedUser } from "../UserState"
import { useSnackbar } from "notistack"
import { send_authorized_request } from "../../Constants/cognito"
import { serviceOrderChip, sort_custom_statuses } from "../../Utils/service"
import CustomerCommunicationModal from "./Modals/CustomerCommunicationModal"

const available_statuses = (status_types, my_user) => {
    return sort_custom_statuses(my_user.client.service_order_statuses).filter((status) => status_types.includes(my_user.client.service_order_statuses[status].type)).reduce((obj, key) => {
        obj[key] = my_user.client.service_order_statuses[key];
        return obj;
    }, {});
}

const get_option = (serviceOrder, my_user, status, status_object) => {
    let disabled = false
    let tooltip = ""
    if (status_object.type === 'WORK_COMPLETE' && serviceOrder.actively_worked) {
        disabled = true
        tooltip = "Work in progress"
    }
    const option =
        <MenuItem key={status} value={status} disabled={disabled}>
            <Grid container direction='column'>
                <Grid>
                    {serviceOrderChip(my_user, status, my_user.client.service_order_statuses[status].type, my_user.client.service_order_statuses[status].customer_communication)}
                </Grid>
                {tooltip &&
                    <Grid>
                        <span style={{ fontSize: '10px', color: '#d32f2f' }}>{tooltip}</span>
                    </Grid>
                }
            </Grid>
        </MenuItem>
    return option
}

export default function ServiceOrderStatusDropdown({
    serviceOrder,
    setServiceOrder,
    setMadeUpdate,
    setServiceOrderSavingStep,
    allow_customer_communication = false,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_user,] = useTrackedUser();
    const statuses = available_statuses(['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) ? ['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'] : [serviceOrder.status_type], my_user) ?? {}
    const [openCustomerCommunicationModal, setOpenCustomerCommunicationModal] = React.useState(false)

    const changeStatus = (e) => {
        setServiceOrderSavingStep(1)
        const new_status = {
            status: e.target.value
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/change_status`, new_status).then((serviceOrder) => {
                setServiceOrderSavingStep(0)
                enqueueSnackbar('Successfully changed status', { variant: 'success' })
                setServiceOrder(serviceOrder.data.data)
                setMadeUpdate(true)
                if (allow_customer_communication && my_user.client.service_order_statuses[new_status.status].customer_communication) {
                    setOpenCustomerCommunicationModal(true)
                }
            }).catch((error) => {
                setServiceOrderSavingStep(0)
                enqueueSnackbar(`Failed to change status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    return (
        <React.Fragment>
            <FormControl sx={{ m: 1 }} size="small">
                <Select
                    labelId="serviceorder-service-status-label"
                    id="serviceorder-service-status"
                    value={serviceOrder.status_name}
                    onChange={changeStatus}
                    // disabled={!['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) || ['NOT_REQUESTED', 'APPROVAL_REQUESTED'].includes(service.customer_approved_status)}
                    renderValue={(status) => {
                        return serviceOrderChip(my_user, status, my_user.client.service_order_statuses[status].type)
                    }}
                >
                    {Object.keys(statuses).map((status) =>
                        get_option(serviceOrder, my_user, status, statuses[status])
                    )}
                </Select>
                {/* {['NOT_REQUESTED', 'APPROVAL_REQUESTED'].includes(serviceOrder.customer_approved_status) &&
                <FormHelperText>No Customer Approval</FormHelperText>
            } */}
            </FormControl>
            <CustomerCommunicationModal
                serviceOrder={serviceOrder}
                setServiceOrder={setServiceOrder}
                setServiceOrderSavingStep={setServiceOrderSavingStep}
                open={openCustomerCommunicationModal}
                closeModal={(success) => {
                    setOpenCustomerCommunicationModal(false)
                }}
                status={serviceOrder.status_name}
            />
        </React.Fragment>
    )
}
